import React from 'react'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'
import { FormControl, FormLabel, IconButton, InputAdornment, TextField } from '@mui/material'
import { inputSizes, inputTypes } from '../../constants/input'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'

const InputPassword = ({
  name,
  control,
  errors,
  size,
  placeholder,
  startIcon,
  label,
  sx,
  sxFC,
  sxFL,
  autoComplete,
}) => {
  const [visible, setVisible] = React.useState('password')
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={''}
      render={({ field }) => (
        <FormControl
          fullWidth
          sx={{
            mb: 1,
            ...sxFC,
          }}
        >
          <FormLabel
            htmlFor={name}
            sx={{
              ...sxFL,
            }}
          >
            {label}
          </FormLabel>
          <TextField
            {...field}
            id={name}
            type={visible}
            size={size}
            placeholder={placeholder}
            fullWidth
            InputProps={{
              ...(startIcon && {
                startAdornment: <InputAdornment position="start">{startIcon}</InputAdornment>,
              }),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() =>
                      setVisible((prev) => (prev === 'password' ? 'text' : 'password'))
                    }
                  >
                    {visible === 'password' ? <VisibilityOffIcon /> : <VisibilityIcon />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            error={!!errors[name]}
            helperText={errors[name] && errors[name].message}
            sx={{ ...sx }}
            autoComplete={autoComplete}
          />
        </FormControl>
      )}
    />
  )
}

InputPassword.defaultProps = {
  size: 'large',
  label: 'Input Label',
  placeholder: 'Input something...',
  autoComplete: 'off',
}

InputPassword.propTypes = {
  name: PropTypes.string.isRequired,
  control: PropTypes.any.isRequired,
  errors: PropTypes.any.isRequired,
  label: PropTypes.string,
  size: PropTypes.oneOf(inputSizes),
  type: PropTypes.oneOf(inputTypes),
  placeholder: PropTypes.string,
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
}

export default InputPassword
